import React from 'react';

import PreviewVideoTag from '../../../../Components/PreviewVideoTag';

export type VideoPreviewProps = {
  thumbnail: string;
  className?: string;
  hidePreviewTag?: boolean;
};

const VideoPreview = ({ thumbnail, className = '', hidePreviewTag = false }: VideoPreviewProps) => (
  <div className={`w-full relative ${className}`}>
    {!hidePreviewTag && <PreviewVideoTag className='absolute inset-x-0 top-1/2 mx-auto w-fit' />}
    <img className='w-full rounded-md' src={thumbnail} />
  </div>
);

export default VideoPreview;
